import { Injectable } from '@angular/core';

import CommunicationHandler, { EventTypeFilter, SubscriptionHandler } from '@mirage-projects/communication-library';

import { LogService } from '../log/log.service';

export interface MessageEvent {
    type: string;
    message: any;
}
/**
 * This service provides communication with third party apps
 */
@Injectable({ providedIn: 'root' })
export class ExternalCommunicationService {
    private communicationHandler: CommunicationHandler;

    constructor(private logService: LogService) {
        this.communicationHandler = new CommunicationHandler();

        // maintain until communication library is fully integrated
        this.logService.info('Communication Library initialized', this.communicationHandler.id);
    }

    /**
     * Create a subscription defined by filters using the communication library.
     * @param filters A list of filters defined by a single string event type or by EventFilter class
     * @example send event in console with -> document.dispatchEvent( new CustomEvent("COMMUNICATION_LIBRARY_DOCUMENT_DRIVER_000", { detail: { type: '', message: '' } } ));
     */
    onEvents(...filters: string[] | EventTypeFilter[]): SubscriptionHandler {
        return this.communicationHandler.onEvents(...filters);
    }

    /**
     * Send an event using the communication library.
     *
     * @param {string} type the event type
     * @param {object} message the event message
     * @param {string} targetOrigin optional param, indicates the url to send the message
     */
    sendEvent(type: string, message: any, targetOrigin?: string): Promise<MessageEvent> {
        const result = this.communicationHandler.sendEvent({ type, message, targetOrigin });
        result.catch((error: any) => {
            this.logService.error(`Error sending event ${type} with message "${message}" in origin "${targetOrigin}": ${error}`);
        });

        return result;
    }
}
